import { useSyncExternalStore } from 'react'
let pending = 0
const listeners = new Set<() => void>()
const subscribe = (listener: () => void) => { listeners.add(listener); return () => { listeners.delete(listener) } }
const snapshot = () => pending
export function beginAppRequest(): () => void {
  pending++; listeners.forEach((listener) => listener())
  let finished = false
  return () => { if (finished) return; finished = true; pending = Math.max(0, pending - 1); listeners.forEach((listener) => listener()) }
}
export function useAppRequests(): number { return useSyncExternalStore(subscribe, snapshot, () => 0) }
